import { Card, Col, Flex, Row } from 'antd';
import { useState } from 'react';
import applicationImage from "../../../assets/img/homepage/applications/Applications.png";
import applicationImage1 from "../../../assets/img/homepage/applications/Applications1.png";
import applicationImage2 from "../../../assets/img/homepage/applications/Applications2.png";
import applicationImage3 from "../../../assets/img/homepage/applications/Applications3.png";
import applicationImage4 from "../../../assets/img/homepage/applications/Applications4.png";
import applicationImage5 from "../../../assets/img/homepage/applications/Applications5.png";
import applicationImage6 from "../../../assets/img/homepage/applications/Applications6.png";
import applicationImage7 from "../../../assets/img/homepage/applications/Applications7.png";

const Application = ({ title, description, imageSrc }) => {
  const [showHoverText, setShowHoverText] = useState(false);

  return (
    <div className="application-card-container">
      <Card
        hoverable={true}
        cover={
          <img src={imageSrc} style={{ height: 300, objectFit: "fill" }} />
        }
        onMouseEnter={() => setShowHoverText(true)}
        onMouseLeave={() => setShowHoverText(false)}
        className="application-card"
      >
        <div className="card-content">
          <Card.Meta title={title} className="custom-card-meta" />
          <div className={`description-container ${showHoverText ? 'show' : ''}`}>
            <div className="hover-title">{title}</div>
            <div className="description-text">
              {description}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

const Applications = ({ isTabletOrMobile }) => {
  return (
    <Flex className='application-backround' justify='center' vertical={true} gap={48}>
      <div className='application-title'>Applications</div>
      <Row gutter={[0, 24]} justify={'center'} style={{ paddingBottom: 60 }}>
        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
          <Application imageSrc={applicationImage} title="Healthcare & Clinical Diagnostics"
            description="Enables accurate disease detection, blood analysis, microbiological testing, and patient health monitoring in hospitals and labs." />
        </Col>
        <Col offset={!isTabletOrMobile && 1} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Application imageSrc={applicationImage1} title="Pharmaceutical & Biotechnology Research"
            description="Enables accurate disease detection, blood analysis, microbiological testing, and patient health monitoring in hospitals and labs." />
        </Col>
        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
          <Application imageSrc={applicationImage2} title="Scientific Research & Life Sciences"
            description="Enables accurate disease detection, blood analysis, microbiological testing, and patient health monitoring in hospitals and labs." />
        </Col>
        <Col offset={!isTabletOrMobile && 1} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Application imageSrc={applicationImage3} title="Industrial & Chemical Testing Laboratories"
            description="Enables accurate disease detection, blood analysis, microbiological testing, and patient health monitoring in hospitals and labs." />
        </Col>
        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
          <Application imageSrc={applicationImage4} title="Food Safety, Agriculture & Environmental Monitoring"
            description="Enables accurate disease detection, blood analysis, microbiological testing, and patient health monitoring in hospitals and labs." />
        </Col>
        <Col offset={!isTabletOrMobile && 1} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Application imageSrc={applicationImage5} title="Forensic Science, Toxicology & Defense Research"
            description="Enables accurate disease detection, blood analysis, microbiological testing, and patient health monitoring in hospitals and labs." />
        </Col>
        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
          <Application imageSrc={applicationImage6} title="Veterinary Diagnostics & Animal Research"
            description="Enables accurate disease detection, blood analysis, microbiological testing, and patient health monitoring in hospitals and labs." />
        </Col>
        <Col offset={!isTabletOrMobile && 1} xl={8} lg={8} md={8} sm={24} xs={24}>
          <Application imageSrc={applicationImage7} title="Aerospace & Advanced Technology Research"
            description="Enables accurate disease detection, blood analysis, microbiological testing, and patient health monitoring in hospitals and labs." />
        </Col>
      </Row>
    </Flex>
  );
}

export default Applications;